import { render, staticRenderFns } from "./UserProfilesDocumentationDialog.vue?vue&type=template&id=f7d832dc&scoped=true&"
import script from "./UserProfilesDocumentationDialog.vue?vue&type=script&lang=js&"
export * from "./UserProfilesDocumentationDialog.vue?vue&type=script&lang=js&"
import style0 from "./UserProfilesDocumentationDialog.vue?vue&type=style&index=0&id=f7d832dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7d832dc",
  null
  
)

export default component.exports